import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcGift(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 7.438h15a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5v-2.5a.5.5 0 0 1 .5-.5m15-1.5a2 2 0 0 1 2 2v2.5a2 2 0 0 1-2 2h-15a2 2 0 0 1-2-2v-2.5a2 2 0 0 1 2-2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.25 10.938H3.75v8.252a2.75 2.75 0 0 0 2.75 2.75h11a2.75 2.75 0 0 0 2.75-2.75zm-1.5 1.5v6.752c0 .69-.56 1.25-1.25 1.25h-11c-.69 0-1.25-.56-1.25-1.25v-6.753z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.75 11.688h-1.5V21h1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.75 4.313a2.437 2.437 0 1 0-4.875 0V5a2.438 2.438 0 0 0 4.875 0zm-2.437-.938c.517 0 .937.42.937.938V5a.937.937 0 1 1-1.875 0v-.687c0-.518.42-.938.938-.938",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.125 4.313a2.437 2.437 0 1 0-4.875 0V5a2.437 2.437 0 1 0 4.875 0zm-2.437-.938c.517 0 .937.42.937.938V5a.937.937 0 1 1-1.875 0v-.687c0-.518.42-.938.938-.938",
    clipRule: "evenodd"
  }));
}
var IcGift = createNolIcon(/*#__PURE__*/forwardRef(SvgIcGift));

export { IcGift as I };
